export default __webpack_public_path__ + "static/media/t10.min.1391c8f4.png";